import { ContentfulImage } from '@ecomm/contentful/components'
import type { HeaderRedesignSchema } from '../schema'

type RightSideImageProps = {
  readonly image?: HeaderRedesignSchema['images']['items'][number]
}
export function RightSideImage({ image }: RightSideImageProps) {
  return image ? (
    <ContentfulImage
      classNameOverride="bg-neutral-light-50 mx-auto h-[77px] w-[77px] rounded-xl md:h-[114px] md:w-[114px]"
      {...image}
      quality={90}
      width={215}
    />
  ) : null
}
